import { Component, OnInit, HostBinding, ViewChild, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResgateConsultaService } from 'src/app/services/http/resgate-consulta.service';
import { first } from 'rxjs/operators';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ModalFotosConsultaComponent } from './modal-fotos-consulta/modal-fotos-consulta.component';
import { ModalEditarConsultaComponent } from './modal-editar-consulta/modal-editar-consulta.component';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/app/services/login.service';
import { ConsultaService } from 'src/app/services/http/consulta.service';

@Component({
  selector: 'app-consulta-resultado',
  templateUrl: './consulta-resultado.component.html',
  styleUrls: ['./consulta-resultado.component.scss']
})
export class ConsultaResultadoComponent implements OnInit {

  @ViewChild(ModalFotosConsultaComponent, { static: false }) modalFotos;
  @ViewChild(ModalEditarConsultaComponent, { static: false }) modalEditarConsulta;
  @HostBinding('class.compacta') compacta: boolean = false;

  @Input() dadosConsulta: any;
  @Input() exibirHeader = true;
  placaMercosul = false;
  qrcodeUrl = "";
  emplacamento = "";
  cliente = false;
  token = '';
  consultas = [];
  exibirBtn = {
    novaConsulta: true,
    editarConsulta: true,
    novoLaudo: true,
    fotos: true,
    imprimir: true,
    imprimirJS: true,
    compacto: true,
  };
  tipoConsultas = [];
  rodapeConsulta = false;
  login: any;

  exibirBotaoRefresh = false;

  iniciaLaudo: boolean = false;
  existeLaudo: boolean = false;

  exibirBinfed: boolean = false;
  removeBinfed: boolean = false;

  tokenIsId: boolean = false;


  constructor(private loginService: LoginService, private msgService: ModalMsgService, private router: Router, private route: ActivatedRoute,
    private resgatarConsultaService: ResgateConsultaService, private laudoUnionService: LaudoUnionService, private consultaService: ConsultaService) {
  }

  urlPdf;

  ngOnInit() {
    this.cliente = this.route.snapshot.data['cliente'];
    if (this.route.snapshot.data['hideNavigation']) {
      this.exibirBtn = {
        novaConsulta: true,
        editarConsulta: true,
        novoLaudo: true,
        fotos: true,
        imprimir: true,
        imprimirJS: true,
        compacto: true,
      }
    }

    this.route.params.pipe(first()).subscribe(p => {
      this.route.url.pipe(first()).subscribe(r => this.qrcodeUrl = environment.homeUrl + '/consulta/' + r.join('/'))
      this.token = p.token;
      this.tokenIsId = p.token != null && !isNaN(Number(p.token));

      if (!this.tokenIsId) {
        if (!this.dadosConsulta) {
          this.getConsulta();
        } else {
          this.exibirHeader = false;
          this.dadosConsulta.consultas.map(c => ({ ...c, status: null, msg: null }));
          this.dadosConsulta.consultas = this.ordernarConsultas();
          this.verificarMercosul(this.dadosConsulta.placaEntrada);
          this.setEmplacamento();
        }
      }

    });

    if (!this.tokenIsId) {
      this.loginService.getLogIn().pipe(first()).subscribe(r => {
        if (!r) {
          this.exibirBtn.novaConsulta = false;
          this.exibirBtn.editarConsulta = false;
          this.exibirBtn.novoLaudo = false;
          this.exibirBtn.fotos = false;
          this.exibirBtn.compacto = false;
          this.exibirBtn.imprimir = true;
          this.exibirBtn.imprimirJS = true;
        }
        this.login = r;
        this.setUrlPdf();
      });
    }

  }

  async getConsulta() {
    try {
      this.dadosConsulta = await this.resgatarConsultaService.carregarConsulta(this.token);
      // this.dadosConsulta = JSON.parse('{"possuiConsultaCredito":false,"motorEntrada":null,"veiculoEncontrado":true,"iniciaLaudo":true,"decisaoCerta":false,"finalizada":true,"unidade":"Union Solutions","renavamEntrada":"01032059939","nomeEntrada":null,"idunidade":1,"cnhEntrada":null,"chassiEntrada":null,"id":923745,"dataCriacao":"29/07/2021 05:59","valorConsulta":null,"dadosResumo":{"fotoModelo":"https://s3-sa-east-1.amazonaws.com/siteunion/CONSULTAVEICULO/resources/modelonaoidentificado2.png","qtdDebitos":0,"qtdMultas":0,"marcaFipe":"","qtdPontosAtencao":0,"modeloFipe":"","qtdRestricoes":0},"possuiConsultaVeicular":true,"tokenConsulta":"a1854ef2-7fd3-4001-9da6-a0f0391c8a03","observacoes":null,"fotosConsulta":[],"documentoEntrada":null,"crlvEntrada":null,"possuiInsumo":false,"chassiPesquisa":"KNAPC817BF7712540","placaPesquisa":"BEX1I08","consultas":[{"tipoConsulta":"DETRAN_PR","nomeConsulta":"Consulta Detran PR","id":"21","consulta":{"marca":"I/KIA SPORTAGE EX2 OFFG4","autuacoes":"23.0","nrTransacao":"514640018599","renavam":"01032059939","listaDadosCertificadoSeguranca":[{"ano":"2017","discriminacao":"LIBERACAO POR ACIDENTE","csv":"152246120"}],"anoFabricacao":null,"valorDebitoMulta":"0.0","chassi":"KNAPC817BF7712540","id":21,"modelo":null,"placa":"BEX1I08"},"codigoControle":"OK"}],"usuario":"admin","placaEntrada":null}');
      let tipoConsultas = this.getTipoConsulta();
      if (tipoConsultas.length > 0) {
        let response = 'push';
        this.laudoUnionService.getTipoConsultas(tipoConsultas, response);
      } else {
        this.msgService.openDialog('Erro ao carregar consulta', '', 'danger');
      }

      //verifica cache
      this.iniciaLaudo = this.dadosConsulta?.iniciaLaudo || false;

      //verifica se já existe laudo com essa consulta
      this.existeLaudo = this.dadosConsulta?.existeLaudo || false;

      // Exibir no menu superior da visualização do laudo, quando o laudo for iniciado ...
      if (this.dadosConsulta.iniciaLaudo) {
        this.exibirBtn = {
          novoLaudo: this.dadosConsulta.iniciaLaudo,
          novaConsulta: false,
          editarConsulta: false,
          fotos: true,
          imprimir: true,
          imprimirJS: true,
          compacto: true,
        }
      }
      this.dadosConsulta.consultas.map(c => ({ ...c, status: null, msg: null }));
      this.dadosConsulta.consultas = this.ordernarConsultas();
      this.verificarMercosul(this.dadosConsulta.placaEntrada);
      this.setEmplacamento();
    } catch (error) {
      this.msgService.openDialog('Erro ao carregar consulta', '', 'danger');
      console.error(error);
    }

    this.setRodapeConsulta();
  }

  getTipoConsulta() {
    this.dadosConsulta.consultas.forEach(c => {
      // this.consultas[this.consultas.push(c.tipoConsulta)];
      this.consultas[this.consultas.push(
        {
          id: Number(c.id),
          tipoConsulta: c.tipoConsulta
        }
      )];
    });
    return this.consultas;
  }

  setEmplacamento() {
    let emplacamento = 'UF - MUNICIPIO';
    let consultas = ['BIN_ESTADUAL', 'AGREGADOS', 'BIN_FEDERAL', 'BIN_FEDERAL_RF', 'BIN_RENAJUD', 'BIN_RF'];
    let dadosConsulta = this.dadosConsulta.consultas.find(c => c.codigoControle == 'OK' && consultas.find(c2 => c.tipoConsulta == c2));
    if (dadosConsulta) {
      let consulta = dadosConsulta.consulta;
      let uf = consulta.uf || consulta.ufMunicipio || 'UF';
      let municipio = consulta.municipio || 'MUNICIPIO';
      emplacamento = uf + ' - ' + municipio;
    }
    emplacamento !== 'UF - MUNICIPIO' ? this.emplacamento = emplacamento : this.emplacamento = null;
  }

  verificarMercosul(placa) {
    if (placa === null || placa === undefined) {
      return;
    }

    placa = placa.replace(/[^0-9a-zA-Z]/, '');
    if (placa[4] == '0') {
      this.placaMercosul = false;
    }
    else {
      this.placaMercosul = !parseInt(placa[4], 10);
    }
  }

  atualizarConsulta(index, novaConsulta) {
    this.dadosConsulta.consultas[index] = novaConsulta;
    window.location.reload();
  }

  ordernarConsultas() {
    let consultas = this.dadosConsulta.consultas;
    let decisaoCerta = this.dadosConsulta.decisaoCerta;
    let consultasOrdenadas = [
      consultas.find(c => c.tipoConsulta === 'BIN_ESTADUAL'),
      consultas.find(c => c.tipoConsulta === 'BATEU'),
      consultas.find(c => c.tipoConsulta === 'DETRAN_PR'),
      consultas.find(c => c.tipoConsulta === 'BIN_FEDERAL'),
      consultas.find(c => c.tipoConsulta === 'BIN_RF'),
      consultas.find(c => c.tipoConsulta === 'BIN_FEDERAL_RF'),
      consultas.find(c => c.tipoConsulta === 'BIN_RENAJUD'),
      consultas.find(c => c.tipoConsulta === 'COTACAO_SEGURO'),
      decisaoCerta ? null : consultas.find(c => c.tipoConsulta === 'AGREGADOS'),
      consultas.find(c => c.tipoConsulta === 'INDICIO_SINISTRO'),
      consultas.find(c => c.tipoConsulta === 'INDICIO_SINISTRO2'),
      decisaoCerta ? { 'tipoConsulta': 'AVISO_CSV' } : null,
      consultas.find(c => c.tipoConsulta === 'PARECER_TECNICO'),
      consultas.find(c => c.tipoConsulta === 'PT'),
      consultas.find(c => c.tipoConsulta === 'DECODIFICADOR'),
      consultas.find(c => c.tipoConsulta === 'DECODIFICADOR_ESPECIAL'),
      consultas.find(c => c.tipoConsulta === 'HISTORICO_VENDA'),
      consultas.find(c => c.tipoConsulta === 'MOTOR'),
      consultas.find(c => c.tipoConsulta === 'GRAVAME'),
      consultas.find(c => c.tipoConsulta === 'GRAVAME_SIMPLES'),
      consultas.find(c => c.tipoConsulta === 'RECALL'),
      consultas.find(c => c.tipoConsulta === 'RENAINF'),
      decisaoCerta ? null : consultas.find(c => c.tipoConsulta === 'RENAVAM'),
      consultas.find(c => c.tipoConsulta === 'LEILAO'),
      consultas.find(c => c.tipoConsulta === 'LEILAO_2'),
      consultas.find(c => c.tipoConsulta === 'LEILAO_3'),
      decisaoCerta ? null : consultas.find(c => c.tipoConsulta === 'LEILAO_CONJUGADO'),
      consultas.find(c => c.tipoConsulta === 'PRECIFICADOR'),
      consultas.find(c => c.tipoConsulta === 'PRECO_MERCADO_MOLICAR'),
      consultas.find(c => c.tipoConsulta === 'PRECO_MERCADO_KBB'),
      consultas.find(c => c.tipoConsulta === 'PRECO_MERCADO_WEBMOTORS'),
      consultas.find(c => c.tipoConsulta === 'DESVALORIZACAO_FIPE'),
      consultas.find(c => c.tipoConsulta === 'PROPRIETARIOS'),
      consultas.find(c => c.tipoConsulta === 'PROPRIETARIOS_UNION'),
      decisaoCerta ? null : consultas.find(c => c.tipoConsulta === 'BIN_FEDERAL_UNION'),
      consultas.find(c => c.tipoConsulta === 'CRLV'),
      consultas.find(c => c.tipoConsulta === 'CRLV_E'),
      consultas.find(c => c.tipoConsulta === 'CNH'),
      consultas.find(c => c.tipoConsulta === 'HISTORICO'),
      consultas.find(c => c.tipoConsulta === 'LOCALIZA_PLACA'),
      consultas.find(c => c.tipoConsulta === 'LOCALIZA_VEICULO'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_PJ'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_PF'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_UNIFICADO_PF'),
      consultas.find(c => c.tipoConsulta === 'RELATORIO_UNIFICADO_PJ'),
      consultas.find(c => c.tipoConsulta === 'PROPRIETARIO_LICENCIAMENTO'),
      consultas.find(c => c.tipoConsulta === 'PRECIFICADOR_DECISAO_CERTA'),
      consultas.find(c => c.tipoConsulta === 'DETRANSC'),
      consultas.find(c => c.tipoConsulta === 'CSV'),
      consultas.find(c => c.tipoConsulta === 'HISTORICORFPRO'),
      consultas.find(c => c.tipoConsulta === 'EXPERIMENTAL'),
    ].filter(c => c);

    if (decisaoCerta) {
      consultasOrdenadas.forEach(c => {
        if (c.tipoConsulta === 'LEILAO') c.nomeConsulta = 'BASE DE LEILÃO 1';
        if (c.tipoConsulta === 'LEILAO_2') c.nomeConsulta = 'BASE DE LEILÃO 2';
        if (c.tipoConsulta === 'LEILAO_3') c.nomeConsulta = 'BASE DE LEILÃO 3';
        if (c.tipoConsulta === 'HISTORICO_VENDA') c.nomeConsulta = 'REMARKETING';
        if (c.tipoConsulta === 'GRAVAME_SIMPLES') c.nomeConsulta = 'GRAVAME (CORTESIA)';
        if (c.tipoConsulta === 'RECALL') c.nomeConsulta = 'RECALL (CORTESIA)';
        if (c.tipoConsulta === 'BIN_RENAJUD') c.nomeConsulta = 'DADOS JUDICIAIS RENAJUD (CORTESIA)';
        if (c.tipoConsulta === 'MOTOR') c.nomeConsulta = 'LOCALIZADOR DE CHASSI E MOTOR (CORTESIA)';
        if (c.tipoConsulta === 'PRECIFICADOR') c.nomeConsulta = 'PREÇO MERCADO E SEGURADORAS (CORTESIA)';
        if (c.tipoConsulta === 'DESVALORIZACAO_FIPE') c.nomeConsulta = 'DESVALORIZAÇÃO MÉDIA (CORTESIA)';
        if (c.tipoConsulta === 'PRECIFICADOR_DECISAO_CERTA') c.nomeConsulta = 'PREÇO MERCADO FINANCEIRAS (CORTESIA)';
        if (c.tipoConsulta === 'PROPRIETARIOS_UNION') c.nomeConsulta = 'HISTÓRICO DE PROPRIETÁRIOS (CORTESIA)';
        //if (c.tipoConsulta === 'BIN_RF' && c.codigoControle === 'OK') this.removeBinfed = true;
        //if (c.tipoConsulta === 'BIN_FEDERAL' && c.codigoControle != 'OK') this.removeBinfed = true;
      });

      if (this.removeBinfed) {
        this.exibirBinfed = false;
        for (let i = 0; i < consultasOrdenadas.length; i++) {
          if (consultasOrdenadas[i].tipoConsulta === 'BIN_FEDERAL') {
            consultasOrdenadas.splice(i--, 1);
          }
        }
      } else {
        for (let i = 0; i < consultasOrdenadas.length; i++) {
          if (consultasOrdenadas[i].tipoConsulta === 'BIN_FEDERAL') {
            this.exibirBinfed = true;
            break;
          }
        }
      }
    }

    return consultasOrdenadas;
  }

  novaConsulta() {
    this.router.navigate(['consulta', 'realizar']);
  }

  redirectNovoLaudo() {

    if (!this.iniciaLaudo) {
      return this.msgService.openDialog(
        'Prazo para resgate expirado!',
        'O prazo para realizar um novo Laudo a partir desta consulta expirou. Favor realizar uma nova consulta.',
        'danger'
      );
    } else if (this.existeLaudo) {
      this.msgService.open(
        'A consulta já pertencente a um Laudo!',
        'Deseja abrir o laudo?',
        'danger',
        null,
        { text: 'Não' },
        { text: 'Abrir laudo' }
      ).then(result => {
        if (result === 'ok') {
          return this.router.navigate(['laudo', 'visualizar', this.dadosConsulta?.tokenLaudo]);
        }
        return;
      }).catch(e => {
        return;
      });
    } else {

      let placaPesquisa = this.dadosConsulta.placaPesquisa ? this.dadosConsulta.placaPesquisa : '';
      let placaEntrada = this.dadosConsulta.placaEntrada ? this.dadosConsulta.placaEntrada : '';

      // Comentado momentaneamente ate ser lançado a funcionalidade de laudo para consultas de credito
      // let documentoEntrada =  this.dadosConsulta.dadosResumoCredito &&
      //                         this.dadosConsulta.dadosResumoCredito.cpfcnpj ?
      //                         this.dadosConsulta.dadosResumoCredito.cpfcnpj :
      //                         this.dadosConsulta.documentoEntrada ?
      //                         this.dadosConsulta.documentoEntrada : '';

      // let parametros = {
      //   placa: placaEntrada || placaPesquisa,
      //   documento: documentoEntrada,
      //   consulta: idConsulta
      // }

      let idConsulta = this.dadosConsulta.id ? this.dadosConsulta.id : '';

      let parametros = {
        placa: placaEntrada || placaPesquisa,
        consulta: idConsulta
      }

      this.router.navigate(['laudo', 'adicionar'],
        {
          queryParams:
            { ...parametros }
        }
      );
    }
  }

  downloadPdf() {
    let token = this.dadosConsulta.tokenConsulta ? this.dadosConsulta.tokenConsulta : this.dadosConsulta.id;
    let reqData = { 'consultaCompacta': this.compacta, 'token': token };
    this.resgatarConsultaService.downloadPdfConsulta(reqData).then(data => {

      let file = new FileReader();

      file.onload = () => {
        const link = document.createElement('a') as HTMLAnchorElement;
        link.href = file.result as string;
        link.download = this.dadosConsulta.placaEntrada ? 'Consulta - ' + this.dadosConsulta.placaEntrada + '.pdf' : 'Consulta Veículo.pdf';
        link.addEventListener('click', () => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(file.result as string);
        })
        document.body.appendChild(link);
        link.click();
      }

      file.readAsDataURL(data);

    }, error => {
      console.error(error);
    });
  }

  btnEditarConsulta() {
    this.modalEditarConsulta.showModal().then(r => {
      if (r) {
        this.token = r;
        this.getConsulta();
      }
    });
  }

  btnFotos() {
    this.modalFotos.showModal(this.dadosConsulta.fotosConsulta || [], this.dadosConsulta.observacoes || '').then(modalResult => {
      if (modalResult) {
        this.resgatarConsultaService.salvarFotosConsulta(this.token, modalResult.observacoes, modalResult.fotos).then(result => {
          if (result) {
            const local = modalResult.fotos.filter(f => !f.remover);
            result['fotos'].forEach((f, i) => f.src = local[i].base64);
            this.dadosConsulta.fotos = result['fotos'];
            this.dadosConsulta.observacoes = result['observacoes'];
          }
        });
      }
    });
  }

  setRodapeConsulta() {
    this.dadosConsulta.consultas.forEach(c => {
      this.tipoConsultas.push(c.tipoConsulta);

    });
    for (let i = 0; i < this.tipoConsultas.length; i++) {
      if (this.tipoConsultas[i] === "BIN_ESTADUAL") {
        this.rodapeConsulta = true;
      }
      if (this.tipoConsultas[i] === "INDICIO_SINISTRO") {
        this.rodapeConsulta = true;
      }
      if (this.tipoConsultas[i] === "INDICIO_SINISTRO2") {
        this.rodapeConsulta = true;
      }
      if (this.tipoConsultas[i] === "PT") {
        this.rodapeConsulta = true;
      }
    }
  }

  toggleCompacta() {
    this.compacta = !this.compacta;
    this.setUrlPdf();
  }

  setUrlPdf() {
    this.urlPdf = environment.wsUrl + 'relatorio/relatorioPdf/' + this.token + (this.compacta ? '/true/' : '/false/');
    if (this.login) {
      this.urlPdf += this.login.id || '';
    }
  }

  impressaoJS() {
    var tempTitle = document.title;
    document.title = 'consulta-' + this.dadosConsulta.placaEntrada || tempTitle;
    window.print();
    document.title = tempTitle;
  }

  printPdf() {
    // 1️⃣ Abre uma aba em branco imediatamente (sincronamente ao clique)
    const novaAba = window.open('', '_blank');
    // 2️⃣ Exibe uma mensagem temporária (HTML simples)
    if (novaAba) {
      novaAba.document.write(`
      <html>
        <head><title>Gerando Relatório...</title></head>
        <body style="font-family: sans-serif; padding: 2rem;">
          <h2>⏳ Gerando relatório PDF...</h2>
          <p>Isso pode levar até 2 minutos. A janela será atualizada automaticamente.</p>
        </body>
      </html>
    `);
    }
    this.consultaService.getRelatorioPdf(this.token).subscribe({
      next: (blob: Blob) => {
        const fileURL = window.URL.createObjectURL(blob);

        // 3️⃣ Se a aba foi aberta com sucesso, redireciona o conteúdo
        if (novaAba) {
          novaAba.location.href = fileURL;
        } else {
          // Fallback: se popup bloqueado mesmo assim
          window.open(fileURL, '_blank');
        }

      },
      error: (err) => {
        console.error('Erro ao baixar PDF:', err);
        if (novaAba) {
          novaAba.document.write('<h3>Erro ao gerar relatório.</h3>');
        }
      },
    });
  }

}
